import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { zFiltersArray } from 'helpers/router';

const eventsSearchSchema = z.object({
  date_range: zFiltersArray(),
  deleteEvent: z.string().optional(),
  filtersDialog: z
    .union([z.literal('date_range'), z.literal('location'), z.literal('type')])
    .optional()
    .catch(undefined),
  location: zFiltersArray(),
  type: zFiltersArray(),
});

export type EventsSearchSchema = z.infer<typeof eventsSearchSchema>;

export const Route = createFileRoute(
  '/_private/_route/_internal/events/events/',
)({
  validateSearch: eventsSearchSchema,
});
